export const mapTemplateNamesListFromApiModel = response => {
  const { data } = response;

  // @todo add infinite load to template list @lukavyi
  return data.map(({ id, attributes: { name } }) => ({ id, name }));
};
